document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("#CollectionFiltersForm");
  if (!form) {
    return;
  }

  const FilterUIManager = {
    priceFilterGroup: document.querySelector(".price-filter-group"),
    priceSelectDisplay: document.querySelector(".price-select-display"),
    priceClearButton: document.getElementById("price-filter-clear"),
    priceRangeDropdown: document.querySelector(".price-range-dropdown"),
    priceSliderComponent: document.querySelector("custom-price-slider"),

    deliveryFilterGroup: document.querySelector(".delivery-filter-group"),
    deliverySelectDisplay: document.querySelector(".delivery-select-display"),
    deliveryClearButton: document.getElementById("delivery-filter-clear"),
    deliveryOptionsDropdown: document.querySelector(
      ".delivery-options-dropdown"
    ),
    deliveryHiddenInput: document.getElementById("delivery-metafield-input"),
    deliveryAuxInput: document.getElementById("delivery-input"),

    videoCertifiedFilterGroup: document.querySelector(
      ".video-certified-filter-group"
    ),
    videoCertifiedSelectDisplay: document.querySelector(
      ".video-certified-select-display"
    ),
    videoCertifiedClearButton: document.getElementById("video-filter-clear"),
    videoCertifiedOptionsDropdown: document.querySelector(
      ".video-options-dropdown"
    ),
    videoCertifiedHiddenInput: document.getElementById(
      "video-certified-metafield-input"
    ),
    videoCertifiedToggle: null,
    _globalClickListener: null,
    _handlePriceSliderUpdateBound: null,

    searchInput: null,
    tagButtons: [],

    sortByInput: document.getElementById("SortBy"),
    sortByDisplay: document.querySelector(".custom-select--text"),
    sortByItems: document.querySelectorAll(".custom-select--item"),
    sortByButton: document.querySelector(".custom-select--button"),

    _isUpdatingDisplays: false,
    _isApplyingFilters: false,

    init: function () {
      this.performInitializationOrReinitialization();

      document.body.addEventListener("facet:updated", () => {
        this.performInitializationOrReinitialization();
      });

      window.addEventListener("load", () => {
        const currentParams = new URLSearchParams(window.location.search);
        if (!currentParams.has("page")) {
          this.clearSearchParamOnPageLoad();
        }

        this.updateAllDisplays(new URLSearchParams(window.location.search));

        if (this.deliveryHiddenInput || this.deliveryAuxInput) {
          const hasActiveDelivery = !!(
            (this.deliveryHiddenInput && this.deliveryHiddenInput.value) ||
            (this.deliveryAuxInput && this.deliveryAuxInput.value)
          );

          if (hasActiveDelivery && this.deliveryClearButton) {
            this.deliveryClearButton.style.display = "";
          }
        }
      });

      window.addEventListener("popstate", (event) => {
        const currentParams = new URLSearchParams(window.location.search);
        if (currentParams.has("page")) {
          return;
        }
      });

      this.registerApplyFilterButton();
    },

    registerApplyFilterButton: function () {
      const applyButtons = document.querySelectorAll(
        ".collection-filters__button"
      );

      applyButtons.forEach((button) => {
        const isInsideMobileButton = button.closest("#mobile-filter-button");

        if (
          !isInsideMobileButton &&
          !button.hasAttribute("data-filter-listener")
        ) {
          button.setAttribute("data-filter-listener", "true");

          button.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            if (this.hasActiveSearch()) {
              this.goToSearchResults();
              return;
            }

            this._isApplyingFilters = true;

            if (typeof window.clearPageParamOnFilterChange === "function") {
              window.clearPageParamOnFilterChange();
            }

            this.closeAllDropdowns();

            setTimeout(() => {
              this.closeAllDropdowns();
            }, 50);

            setTimeout(() => {
              const deliveryDropdowns = document.querySelectorAll(
                ".delivery-options-dropdown"
              );
              deliveryDropdowns.forEach((dropdown) => {
                dropdown.style.display = "none";
              });
            }, 100);

            if (typeof window.syncMobileInputsBeforeApply === "function") {
              window.syncMobileInputsBeforeApply();
            }

            if (typeof window.applyFiltersGlobal === "function") {
              window.applyFiltersGlobal(true);
            } else {
              console.error("Error");
            }

            setTimeout(() => {
              this._isApplyingFilters = false;

              setTimeout(() => {
                const deliveryDropdowns = document.querySelectorAll(
                  ".delivery-options-dropdown"
                );
                deliveryDropdowns.forEach((dropdown) => {
                  dropdown.style.display = "";
                });
              }, 500);
            }, 200);
          });
        }
      });

      const form = document.querySelector("#CollectionFiltersForm");
      if (form && !form.hasAttribute("data-filter-listener")) {
        form.setAttribute("data-filter-listener", "true");
        form.addEventListener("submit", (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (this.hasActiveSearch()) {
            this.goToSearchResults();
            return;
          }

          if (typeof window.clearPageParamOnFilterChange === "function") {
            window.clearPageParamOnFilterChange();
          }

          this.closeAllDropdowns();

          if (typeof window.applyFiltersGlobal === "function") {
            window.applyFiltersGlobal(true);
          } else {
            console.error("Error");
          }
        });
      }

      const mobileForm = document.querySelector("#FacetFiltersFormMobile");
      if (mobileForm && !mobileForm.hasAttribute("data-filter-listener")) {
        mobileForm.setAttribute("data-filter-listener", "true");
        mobileForm.addEventListener("submit", (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (this.hasActiveSearch()) {
            this.goToSearchResults();
            return;
          }

          if (typeof window.clearPageParamOnFilterChange === "function") {
            window.clearPageParamOnFilterChange();
          }

          this.closeAllDropdowns();

          if (typeof window.applyFiltersGlobal === "function") {
            window.applyFiltersGlobal(true);
          } else {
            console.error("Error:");
          }
        });
      }
    },

    performInitializationOrReinitialization: function () {
      this.priceFilterGroup = document.querySelector(".price-filter-group");
      this.priceSelectDisplay = document.querySelector(".price-select-display");
      this.priceClearButton = document.getElementById("price-filter-clear");
      this.priceRangeDropdown = document.querySelector(".price-range-dropdown");
      this.priceSliderComponent = document.querySelector("custom-price-slider");

      if (!this.priceSliderComponent) {
        console.warn(
          "[PRICE-INIT] custom-price-slider no encontrado en esta colección"
        );
        console.warn("[PRICE-INIT] URL actual:", window.location.pathname);
      }

      this.deliveryFilterGroup = document.querySelector(
        ".delivery-filter-group"
      );
      this.deliverySelectDisplay = document.querySelector(
        ".delivery-select-display"
      );
      this.deliveryClearButton = document.getElementById(
        "delivery-filter-clear"
      );
      this.deliveryOptionsDropdown = document.querySelector(
        ".delivery-options-dropdown"
      );
      this.deliveryHiddenInput = document.getElementById(
        "delivery-metafield-input"
      );
      this.deliveryAuxInput = document.getElementById("delivery-input");

      if (this.deliveryHiddenInput || this.deliveryAuxInput) {
        this._setupDeliveryInputObservers();
      }

      this.videoCertifiedFilterGroup = document.querySelector(
        ".video-certified-filter-group"
      );
      this.videoCertifiedSelectDisplay = document.querySelector(
        ".video-certified-select-display"
      );
      this.videoCertifiedClearButton =
        document.getElementById("video-filter-clear");
      this.videoCertifiedOptionsDropdown = document.querySelector(
        ".video-options-dropdown"
      );
      this.videoCertifiedHiddenInput = document.getElementById(
        "video-certified-metafield-input"
      );
      this.videoCertifiedToggle = document.getElementById(
        "video-certified-toggle"
      );

      this.searchInput = document.getElementById("search-input");
      this.tagButtons = document.querySelectorAll(".collection-tags__tag");

      this.sortByInput = document.getElementById("SortBy");
      this.sortByDisplay = document.querySelector(".custom-select--text");
      this.sortByItems = document.querySelectorAll(".custom-select--item");
      this.sortByButton = document.querySelector(".custom-select--button");

      this.registerPriceFilterEvents();
      this.registerDeliveryFilterEvents();
      this.registerVideoCertifiedFilterEvents();
      this.registerVideoCertifiedToggleEvents();
      this.registerTagEvents();
      this.registerSearchEvents();
      this.registerSortByEvents();

      this.setupDynamicFiltersSync();

      if (this.priceSliderComponent) {
        if (this._handlePriceSliderUpdateBound) {
          this.priceSliderComponent.removeEventListener(
            "price-updated",
            this._handlePriceSliderUpdateBound
          );
        }
        this._handlePriceSliderUpdateBound =
          this.handlePriceSliderUpdate.bind(this);
        this.priceSliderComponent.addEventListener(
          "price-updated",
          this._handlePriceSliderUpdateBound
        );
      }

      this.updateAllDisplays(new URLSearchParams(window.location.search));
      this.closeDropdownsOnClickOutside();

      this.registerMobileApplyButton();

      this.preventPaginationInterference();
    },

    registerMobileApplyButton: function () {
      const mobileApplyButton = document.querySelector(".mobile-filters-apply");
      if (
        mobileApplyButton &&
        !mobileApplyButton.hasAttribute("data-filter-listener")
      ) {
        mobileApplyButton.setAttribute("data-filter-listener", "true");

        mobileApplyButton.removeAttribute("onclick");

        mobileApplyButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (this.hasActiveSearch()) {
            this.goToSearchResults();
            return;
          }

          this._isApplyingFilters = true;

          if (typeof window.clearPageParamOnFilterChange === "function") {
            window.clearPageParamOnFilterChange();
          }

          const facetDrawer = document.querySelector("#Facet-Drawer");
          if (facetDrawer) {
            const priceGroups = facetDrawer.querySelectorAll(
              ".price-filter-group.active"
            );
            const deliveryGroups = facetDrawer.querySelectorAll(
              ".delivery-filter-group.active"
            );
            const videoGroups = facetDrawer.querySelectorAll(
              ".video-certified-filter-group.active"
            );

            priceGroups.forEach((group) => group.classList.remove("active"));
            deliveryGroups.forEach((group) => group.classList.remove("active"));
            videoGroups.forEach((group) => group.classList.remove("active"));
          }

          if (this.priceFilterGroup) {
            this.priceFilterGroup.classList.remove("active");
          }
          if (this.deliveryFilterGroup) {
            this.deliveryFilterGroup.classList.remove("active");
          }
          if (this.videoCertifiedFilterGroup) {
            this.videoCertifiedFilterGroup.classList.remove("active");
          }

          this.closeAllDropdowns();

          if (typeof window.syncMobileInputsBeforeApply === "function") {
            window.syncMobileInputsBeforeApply();
          }

          if (typeof window.applyFiltersGlobal === "function") {
            window.applyFiltersGlobal(true);
          } else {
            console.error("Error:");
          }

          setTimeout(() => {
            this._isApplyingFilters = false;

            if (
              window.mobileFiltersInstance &&
              typeof window.mobileFiltersInstance._closeDrawer === "function"
            ) {
              window.mobileFiltersInstance._closeDrawer();
            } else {
              const facetDrawer = document.getElementById("Facet-Drawer");
              if (facetDrawer && facetDrawer.classList.contains("active")) {
                facetDrawer.classList.remove("active");
                document.body.classList.remove("overflow-hidden");
                document.body.style.overflow = "";

                const clickCapture =
                  document.querySelector(".click-capture") ||
                  document.querySelector(".searchform--click-capture");
                if (clickCapture) {
                  clickCapture.classList.remove("active");
                }
              }
            }
          }, 100);
        });
      }
    },

    updatePriceDisplay: function (params) {
      if (!this.priceSelectDisplay)
        this.priceSelectDisplay = document.querySelector(
          ".price-select-display"
        );
      if (!this.priceClearButton)
        this.priceClearButton = document.getElementById("price-filter-clear");
      if (!this.priceFilterGroup)
        this.priceFilterGroup = document.querySelector(".price-filter-group");
      if (!this.priceSliderComponent)
        this.priceSliderComponent = document.querySelector(
          "custom-price-slider"
        );

      const gte = params.get("filter.v.price.gte");
      const lte = params.get("filter.v.price.lte");
      const currencySymbol =
        this.priceSelectDisplay?.dataset.currencySymbol || "$";

      const sliderInstance = this.priceSliderComponent?.noUiSliderInstance;
      const defaultMin = sliderInstance
        ? String(sliderInstance.options.range.min)
        : this.priceSliderComponent?.querySelector(".price_slider")?.dataset
            .min || "0";
      const defaultMax = sliderInstance
        ? String(sliderInstance.options.range.max)
        : this.priceSliderComponent?.querySelector(".price_slider")?.dataset
            .max || "Infinity";

      if (this.priceSelectDisplay) {
        if (gte || lte) {
          const displayMin = gte || defaultMin;
          const displayMax = lte || defaultMax;
          this.priceSelectDisplay.textContent = `${currencySymbol}${displayMin} - ${currencySymbol}${displayMax}`;
          if (this.priceClearButton) this.priceClearButton.style.display = "";
          this.priceFilterGroup?.classList.add("filter-active");

          if (typeof window.syncBothSliders === "function") {
            setTimeout(() => {
              window.syncBothSliders(
                parseFloat(displayMin),
                parseFloat(displayMax)
              );
            }, 100);
          }
        } else {
          this.priceSelectDisplay.textContent =
            this.priceSelectDisplay.dataset.defaultText || "Select range";
          if (this.priceClearButton)
            this.priceClearButton.style.display = "none";
          this.priceFilterGroup?.classList.remove("filter-active");
        }
      }
    },

    handlePriceSliderUpdate: function (event) {
      if (!this.priceSelectDisplay) {
        this.priceSelectDisplay = document.querySelector(
          ".price-select-display"
        );
        if (!this.priceSelectDisplay) return;
      }
      if (!this.priceClearButton)
        this.priceClearButton = document.getElementById("price-filter-clear");
      if (!this.priceFilterGroup)
        this.priceFilterGroup = document.querySelector(".price-filter-group");

      const { min, max } = event.detail;
      const currencySymbol =
        this.priceSelectDisplay.dataset.currencySymbol || "$";
      this.priceSelectDisplay.textContent = `${currencySymbol}${min} - ${currencySymbol}${max}`;

      let isDefaultState = false;
      if (
        this.priceSliderComponent &&
        this.priceSliderComponent.noUiSliderInstance
      ) {
        const sliderOptions =
          this.priceSliderComponent.noUiSliderInstance.options;
        const defaultSliderMin = sliderOptions.range.min;
        const defaultSliderMax = sliderOptions.range.max;
        if (min === defaultSliderMin && max === defaultSliderMax) {
          isDefaultState = true;
        }
      }

      if (this.priceClearButton) {
        this.priceClearButton.style.display = isDefaultState ? "none" : "";
      }
      if (this.priceFilterGroup) {
        if (isDefaultState) {
          this.priceFilterGroup.classList.remove("filter-active");
        } else {
          this.priceFilterGroup.classList.add("filter-active");
        }
      }

      if (typeof window.syncBothSliders === "function") {
        setTimeout(() => {
          window.syncBothSliders(min, max);
        }, 50);
      }
    },

    updateDeliveryDisplay: function (params, shouldOpenDropdown = false) {
      const deliveryValue = params.get("delivery");
      const deliverySpeedValue = params.get(
        "filter.p.m.wk_custom_field.cus_delivery_speed"
      );

      if (!this.deliveryClearButton) {
        this.deliveryClearButton = document.getElementById(
          "delivery-filter-clear"
        );
      }

      const deliveryInputValue = this.deliveryAuxInput
        ? this.deliveryAuxInput.value
        : "";
      const deliveryHiddenInputValue = this.deliveryHiddenInput
        ? this.deliveryHiddenInput.value
        : "";

      const hasActiveDeliveryFilter = !!(
        deliveryValue ||
        deliverySpeedValue ||
        (deliveryInputValue && deliveryInputValue.trim() !== "") ||
        (deliveryHiddenInputValue && deliveryHiddenInputValue.trim() !== "")
      );

      const activeDeliveryValue =
        deliveryValue ||
        deliverySpeedValue ||
        deliveryInputValue ||
        deliveryHiddenInputValue;

      if (this.deliverySelectDisplay) {
        if (hasActiveDeliveryFilter) {
          this.deliverySelectDisplay.textContent = activeDeliveryValue.replace(
            /\+/g,
            " "
          );

          if (this.deliveryClearButton) {
            this.deliveryClearButton.style.display = "";
          }

          // Only add active class (which opens dropdown) when explicitly requested
          if (shouldOpenDropdown && this.deliveryFilterGroup) {
            this.deliveryFilterGroup.classList.add("active");
          }
        } else {
          this.deliverySelectDisplay.textContent =
            this.deliverySelectDisplay.dataset.defaultText || "Select delivery";
          if (this.deliveryClearButton)
            this.deliveryClearButton.style.display = "none";
          if (this.deliveryFilterGroup)
            this.deliveryFilterGroup.classList.remove("active");
        }
      }

      this.syncDeliveryDisplayWithMobile(activeDeliveryValue || "");
    },

    syncDeliveryDisplayWithMobile: function (deliveryValue) {
      const facetDrawer = document.getElementById("Facet-Drawer");
      if (!facetDrawer) return;

      try {
        const mobileDeliveryCheckboxes = facetDrawer.querySelectorAll(
          'input[name="filter.p.m.wk_custom_field.cus_delivery_speed"]'
        );

        mobileDeliveryCheckboxes.forEach((checkbox) => {
          const shouldBeChecked =
            checkbox.value === deliveryValue && deliveryValue !== "";

          if (checkbox.checked !== shouldBeChecked) {
            checkbox.checked = shouldBeChecked;

            const deliveryElement = checkbox.closest("li");
            if (deliveryElement) {
              if (shouldBeChecked) {
                deliveryElement.classList.add("active");
              } else {
                deliveryElement.classList.remove("active");
              }
            }
          }
        });
      } catch (error) {
        console.warn(
          "[FilterUIManager] Error syncing delivery with mobile:",
          error
        );
      }
    },

    updateVideoCertifiedDisplay: function (params) {
      const certifiedValue = params.get("filter.p.m.custom.certified");
      if (this.videoCertifiedSelectDisplay) {
        if (certifiedValue === "View all") {
          this.videoCertifiedSelectDisplay.textContent = "View all";
          this.videoCertifiedFilterGroup?.classList.add("active");
          this.videoCertifiedClearButton?.classList.add("visible");
        } else {
          this.videoCertifiedSelectDisplay.textContent = "All";
          this.videoCertifiedFilterGroup?.classList.remove("active");
          this.videoCertifiedClearButton?.classList.remove("visible");
          if (this.videoCertifiedHiddenInput)
            this.videoCertifiedHiddenInput.value = "";
        }
      }
    },

    updateVideoCertifiedToggleDisplay: function (params) {
      if (!this.videoCertifiedToggle) return;
      const certifiedValue = params.get("filter.p.m.custom.certified");
      this.videoCertifiedToggle.checked = certifiedValue === "View all";

      // Sync with mobile drawer checkbox (dynamic detection)
      const facetDrawer = document.getElementById("Facet-Drawer");
      if (facetDrawer) {
        const mobileVideoCertifiedCheckboxes = facetDrawer.querySelectorAll(
          'input[type="checkbox"][name="filter.p.m.custom.certified"], input[type="checkbox"][name*="certified"], input[type="checkbox"][value="View all"]'
        );

        mobileVideoCertifiedCheckboxes.forEach((checkbox) => {
          checkbox.checked = certifiedValue === "View all";
        });
      }
    },

    updateTagDisplay: function (params) {
      const activeTags = params.getAll("filter.p.tag");
      this.tagButtons.forEach((button) => {
        if (activeTags.includes(button.textContent.trim())) {
          button.classList.add("collection-tags__tag--active");
        } else {
          button.classList.remove("collection-tags__tag--active");
        }
      });

      this.syncTagDisplayWithMobile(activeTags);
    },

    syncTagDisplayWithMobile: function (activeTags) {
      const facetDrawer = document.getElementById("Facet-Drawer");
      if (!facetDrawer) return;

      try {
        const mobileTagCheckboxes = facetDrawer.querySelectorAll(
          'input[name="filter.p.tag"]'
        );

        mobileTagCheckboxes.forEach((checkbox) => {
          const tagValue = checkbox.value;
          const shouldBeChecked = activeTags.includes(tagValue);

          if (checkbox.checked !== shouldBeChecked) {
            checkbox.checked = shouldBeChecked;

            const tagElement = checkbox.closest("li");
            if (tagElement) {
              if (shouldBeChecked) {
                tagElement.classList.add("active");
              } else {
                tagElement.classList.remove("active");
              }
            }
          }
        });
      } catch (error) {
        console.warn(
          "[FilterUIManager] Error syncing tag display with mobile:",
          error
        );
      }
    },

    updateSortByDisplay: function (params) {
      const sortByValue = params.get("sort_by");

      if (!this.sortByInput) {
        this.sortByInput = document.getElementById("SortBy");
      }

      if (!this.sortByDisplay) {
        this.sortByDisplay = document.querySelector(".custom-select--text");
      }

      if (!this.sortByItems || this.sortByItems.length === 0) {
        this.sortByItems = document.querySelectorAll(".custom-select--item");
      }

      if (this.sortByInput && sortByValue) {
        this.sortByInput.value = sortByValue;
      }

      if (this.sortByDisplay) {
        const selectedItem = Array.from(this.sortByItems).find(
          (item) => item.dataset.value === sortByValue
        );

        if (selectedItem) {
          this.sortByDisplay.textContent = selectedItem.textContent.trim();
        } else {
          this.sortByDisplay.textContent = "Sort by";
        }
      }

      if (this.sortByItems && this.sortByItems.length > 0) {
        this.sortByItems.forEach((item) => {
          if (item.dataset.value === sortByValue) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
      }
    },

    updateAllDisplays: function (params) {
      if (this._isUpdatingDisplays) {
        return;
      }

      this._isUpdatingDisplays = true;

      try {
        this.updatePriceDisplay(params);
        this.updateDeliveryDisplay(params, false); // Don't open dropdown during general updates
        this.updateVideoCertifiedDisplay(params);
        this.updateVideoCertifiedToggleDisplay(params);
        this.updateTagDisplay(params);
        this.updateSearchInputDisplay(params);
        this.updateSortByDisplay(params);
        this.updateDynamicFiltersFromParams(params);
      } finally {
        this._isUpdatingDisplays = false;
      }
    },

    registerPriceFilterEvents: function () {
      if (this.priceFilterGroup) {
        this.priceFilterGroup.addEventListener("click", (e) => {
          if (this._isApplyingFilters) {
            return;
          }

          const isClickOnDropdownContent = e.target.closest(
            ".price-range-dropdown"
          );
          const isClickOnInteractiveElementsInsideDropdown = e.target.closest(
            ".noUi-handle, input, .noUi-connect"
          );

          if (
            !isClickOnDropdownContent ||
            (isClickOnDropdownContent &&
              !isClickOnInteractiveElementsInsideDropdown &&
              !e.target.closest("label"))
          ) {
            const isClickOnPriceSelectWrapper = e.target.closest(
              ".price-select-wrapper"
            );
            const isClickOnPriceSelectDisplay = e.target.classList.contains(
              "price-select-display"
            );
            const isClickOnPriceFilterGroup =
              e.target === this.priceFilterGroup;

            const isValidPriceClick =
              isClickOnPriceFilterGroup ||
              isClickOnPriceSelectDisplay ||
              (isClickOnPriceSelectWrapper &&
                isClickOnPriceSelectWrapper.closest(".price-filter-group") ===
                  this.priceFilterGroup) ||
              e.target === this.priceRangeDropdown;

            if (isValidPriceClick) {
              e.stopPropagation();

              this.priceFilterGroup.classList.toggle("active");
              this.deliveryFilterGroup?.classList.remove("active");
              this.videoCertifiedFilterGroup?.classList.remove("active");
            }
          }
        });
      }
      if (this.priceClearButton) {
        this.priceClearButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (this.priceSliderComponent) {
            try {
              if (typeof this.priceSliderComponent.resetSlider === "function") {
                this.priceSliderComponent.resetSlider();
              } else {
                console.warn("[PRICE-RESET] resetSlider no es una función");
              }
            } catch (error) {
              console.error("[PRICE-RESET] Error al resetear:", error);
            }
          } else {
            this.priceSliderComponent = document.querySelector(
              "custom-price-slider"
            );
            if (this.priceSliderComponent) {
              try {
                this.priceSliderComponent.resetSlider();
              } catch (error) {
                console.error(
                  "[PRICE-RESET] Error al resetear después de re-búsqueda:",
                  error
                );
              }
            } else {
              console.error(
                "[PRICE-RESET] custom-price-slider no existe en esta colección"
              );
            }
          }

          if (typeof window.resetAllPriceInputs === "function") {
            setTimeout(() => {
              window.resetAllPriceInputs();
            }, 100);
          } else {
            const mobileMinInput = document.getElementById("price-min-mobile");
            const mobileMaxInput = document.getElementById("price-max-mobile");
            const mobileGteHidden = document.getElementById("price-gte-mobile");
            const mobileLteHidden = document.getElementById("price-lte-mobile");
            const mobilePriceSlider = document.querySelector(
              "#Facet-Drawer custom-price-slider"
            );

            if (mobileMinInput) mobileMinInput.value = "";
            if (mobileMaxInput) mobileMaxInput.value = "";
            if (mobileGteHidden) mobileGteHidden.value = "";
            if (mobileLteHidden) mobileLteHidden.value = "";

            if (
              mobilePriceSlider &&
              typeof mobilePriceSlider.resetSlider === "function"
            ) {
              try {
                mobilePriceSlider.resetSlider();
              } catch (error) {
                console.warn(
                  "[PRICE-RESET] Error reseteando slider móvil:",
                  error
                );
              }
            }

            const desktopMinInput = document.getElementById("price-min");
            const desktopMaxInput = document.getElementById("price-max");
            const desktopGteHidden = document.getElementById("price-gte");
            const desktopLteHidden = document.getElementById("price-lte");

            if (desktopMinInput) desktopMinInput.value = "";
            if (desktopMaxInput) desktopMaxInput.value = "";
            if (desktopGteHidden) desktopGteHidden.value = "";
            if (desktopLteHidden) desktopLteHidden.value = "";
          }
        });
      } else {
        console.warn(
          "[PRICE-RESET] priceClearButton no encontrado en esta colección"
        );
      }
    },

    registerDeliveryFilterEvents: function () {
      if (this.deliveryFilterGroup) {
        this.deliveryFilterGroup.addEventListener("click", (e) => {
          if (this._isApplyingFilters) {
            return;
          }

          if (e.target.closest(".delivery-options-dropdown")) {
            return;
          }

          const isClickOnDeliverySelectWrapper = e.target.closest(
            ".delivery-select-wrapper"
          );
          const isClickOnDeliverySelectDisplay = e.target.classList.contains(
            "delivery-select-display"
          );
          const isClickOnDeliveryFilterGroup =
            e.target === this.deliveryFilterGroup;

          const isValidDeliveryClick =
            isClickOnDeliveryFilterGroup ||
            isClickOnDeliverySelectDisplay ||
            (isClickOnDeliverySelectWrapper &&
              isClickOnDeliverySelectWrapper.closest(
                ".delivery-filter-group"
              ) === this.deliveryFilterGroup);

          if (isValidDeliveryClick) {
            e.stopPropagation();

            this.deliveryFilterGroup.classList.toggle("active");
            this.priceFilterGroup?.classList.remove("active");
            this.videoCertifiedFilterGroup?.classList.remove("active");
          }
        });
      }

      const deliveryOptionDivs =
        this.deliveryOptionsDropdown?.querySelectorAll(".delivery-option");

      deliveryOptionDivs?.forEach((optionDiv) => {
        optionDiv.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const value = e.currentTarget.dataset.value;

          deliveryOptionDivs.forEach((div) => div.classList.remove("active"));
          e.currentTarget.classList.add("active");

          if (this.deliveryHiddenInput) {
            this.deliveryHiddenInput.value = value;
          }
          if (this.deliveryAuxInput) {
            this.deliveryAuxInput.value = value;
            if (this.deliverySelectDisplay && value) {
              const labelElement = e.currentTarget.querySelector(
                ".delivery-option-label"
              );
              this.deliverySelectDisplay.textContent = labelElement
                ? labelElement.textContent.trim()
                : value;
            } else if (this.deliverySelectDisplay) {
              this.deliverySelectDisplay.textContent =
                this.deliverySelectDisplay.dataset.defaultText ||
                "Select delivery";
            }
          }

          if (this.deliveryClearButton && value) {
            this.deliveryClearButton.style.display = "";
          }

          this.syncDeliveryWithMobile(value);

          this.deliveryFilterGroup.classList.remove("active");
          if (this.deliveryOptionsDropdown) {
            this.deliveryOptionsDropdown.classList.remove("open");
          }
        });
      });

      if (this.deliveryClearButton) {
        this.deliveryClearButton.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (this.deliveryHiddenInput) this.deliveryHiddenInput.value = "";
          if (this.deliveryAuxInput) this.deliveryAuxInput.value = "";

          if (this.deliverySelectDisplay) {
            this.deliverySelectDisplay.textContent =
              this.deliverySelectDisplay.dataset.defaultText ||
              "Select delivery";
          }

          deliveryOptionDivs?.forEach((div) => div.classList.remove("active"));

          this.syncDeliveryWithMobile("");

          const form = document.querySelector("#CollectionFiltersForm");
          if (form) {
            const deliveryInput = form.querySelector(
              'input[name="filter.p.m.wk_custom_field.cus_delivery_speed"]'
            );
            if (deliveryInput) deliveryInput.value = "";

            const auxDeliveryInput = form.querySelector(
              'input[name="delivery"]'
            );
            if (auxDeliveryInput) auxDeliveryInput.value = "";
          }
        });
      }

      this.setupMobileDeliverySync();
    },

    syncDeliveryWithMobile: function (deliveryValue) {
      const facetDrawer = document.getElementById("Facet-Drawer");
      if (!facetDrawer) return;

      try {
        const mobileDeliveryCheckboxes = facetDrawer.querySelectorAll(
          'input[name="filter.p.m.wk_custom_field.cus_delivery_speed"]'
        );

        mobileDeliveryCheckboxes.forEach((checkbox) => {
          checkbox.checked =
            checkbox.value === deliveryValue && deliveryValue !== "";

          const deliveryElement = checkbox.closest("li");
          if (deliveryElement) {
            if (checkbox.checked) {
              deliveryElement.classList.add("active");
            } else {
              deliveryElement.classList.remove("active");
            }
          }
        });
      } catch (error) {
        console.warn(
          "[FilterUIManager] Error syncing delivery with mobile:",
          error
        );
      }
    },

    setupMobileDeliverySync: function () {
      const facetDrawer = document.getElementById("Facet-Drawer");
      if (!facetDrawer) return;

      const handleMobileDeliveryChange = (event) => {
        const checkbox = event.target;

        if (
          checkbox.type === "checkbox" &&
          checkbox.name === "filter.p.m.wk_custom_field.cus_delivery_speed"
        ) {
          if (checkbox.checked) {
            const allDeliveryCheckboxes = facetDrawer.querySelectorAll(
              'input[name="filter.p.m.wk_custom_field.cus_delivery_speed"]'
            );

            allDeliveryCheckboxes.forEach((otherCheckbox) => {
              if (otherCheckbox !== checkbox) {
                otherCheckbox.checked = false;

                const otherElement = otherCheckbox.closest("li");
                if (otherElement) {
                  otherElement.classList.remove("active");
                }
              }
            });

            const selectedElement = checkbox.closest("li");
            if (selectedElement) {
              selectedElement.classList.add("active");
            }

            this.syncDeliveryWithDesktop(checkbox.value);
          } else {
            const deliveryElement = checkbox.closest("li");
            if (deliveryElement) {
              deliveryElement.classList.remove("active");
            }

            this.syncDeliveryWithDesktop("");
          }
        }
      };

      facetDrawer.addEventListener(
        "change",
        handleMobileDeliveryChange.bind(this)
      );

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const deliveryCheckboxes = node.querySelectorAll
                ? node.querySelectorAll(
                    'input[name="filter.p.m.wk_custom_field.cus_delivery_speed"]'
                  )
                : [];

              deliveryCheckboxes.forEach((checkbox) => {
                if (!checkbox.hasAttribute("data-delivery-sync-listener")) {
                  checkbox.setAttribute("data-delivery-sync-listener", "true");
                  checkbox.addEventListener(
                    "change",
                    handleMobileDeliveryChange.bind(this)
                  );
                }
              });
            }
          });
        });
      });

      observer.observe(facetDrawer, { childList: true, subtree: true });

      const syncInitialDeliveryState = () => {
        const currentDeliveryValue =
          this.deliveryHiddenInput?.value || this.deliveryAuxInput?.value || "";

        if (currentDeliveryValue) {
          this.syncDeliveryWithMobile(currentDeliveryValue);
        }
        const checkedMobileDelivery = facetDrawer.querySelector(
          'input[name="filter.p.m.wk_custom_field.cus_delivery_speed"]:checked'
        );

        if (
          checkedMobileDelivery &&
          checkedMobileDelivery.value &&
          !this.deliveryHiddenInput?.value &&
          !this.deliveryAuxInput?.value
        ) {
          this.syncDeliveryWithDesktop(checkedMobileDelivery.value);
        }
      };

      const drawerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class"
          ) {
            const isActive = facetDrawer.classList.contains("active");
            if (isActive) {
              setTimeout(syncInitialDeliveryState, 100);
            }
          }
        });
      });

      drawerObserver.observe(facetDrawer, { attributes: true });
    },

    syncDeliveryWithDesktop: function (deliveryValue) {
      try {
        if (this.deliveryHiddenInput) {
          this.deliveryHiddenInput.value = deliveryValue;
        }
        if (this.deliveryAuxInput) {
          this.deliveryAuxInput.value = deliveryValue;
        }

        if (this.deliverySelectDisplay) {
          if (deliveryValue && deliveryValue.trim() !== "") {
            this.deliverySelectDisplay.textContent = deliveryValue.replace(
              /\+/g,
              " "
            );

            if (this.deliveryClearButton) {
              this.deliveryClearButton.style.display = "";
            }

            // Don't automatically add active class to prevent dropdown from opening during sync
            // The active class will be added when the user actually clicks on the delivery filter
          } else {
            this.deliverySelectDisplay.textContent =
              this.deliverySelectDisplay.dataset.defaultText ||
              "Select delivery";

            if (this.deliveryClearButton) {
              this.deliveryClearButton.style.display = "none";
            }

            if (this.deliveryFilterGroup) {
              this.deliveryFilterGroup.classList.remove("active");
            }
          }
        }

        const deliveryOptionDivs =
          this.deliveryOptionsDropdown?.querySelectorAll(".delivery-option");
        deliveryOptionDivs?.forEach((div) => {
          if (div.dataset.value === deliveryValue && deliveryValue !== "") {
            div.classList.add("active");
          } else {
            div.classList.remove("active");
          }
        });
      } catch (error) {
        console.warn(
          "[FilterUIManager] Error syncing delivery with desktop:",
          error
        );
      }
    },

    registerVideoCertifiedFilterEvents: function () {
      if (this.videoCertifiedOptionsDropdown) {
        const newDropdown = this.videoCertifiedOptionsDropdown.cloneNode(true);
        this.videoCertifiedOptionsDropdown.parentNode.replaceChild(
          newDropdown,
          this.videoCertifiedOptionsDropdown
        );
        this.videoCertifiedOptionsDropdown = newDropdown;

        this.videoCertifiedOptionsDropdown
          .querySelectorAll(".dropdown-option")
          .forEach((option) => {
            option.addEventListener("click", (event) => {
              event.preventDefault();
              const value = option.dataset.value;
              if (this.videoCertifiedHiddenInput)
                this.videoCertifiedHiddenInput.value = value;
              if (this.videoCertifiedSelectDisplay)
                this.videoCertifiedSelectDisplay.textContent =
                  option.textContent;
              this.videoCertifiedOptionsDropdown.classList.remove("open");
              this.videoCertifiedFilterGroup?.classList.toggle(
                "active",
                !!value
              );
              this.videoCertifiedClearButton?.classList.toggle(
                "visible",
                !!value
              );
            });
          });
      }

      if (this.videoCertifiedClearButton) {
        const newClearButton = this.videoCertifiedClearButton.cloneNode(true);
        this.videoCertifiedClearButton.parentNode.replaceChild(
          newClearButton,
          this.videoCertifiedClearButton
        );
        this.videoCertifiedClearButton = newClearButton;

        this.videoCertifiedClearButton.addEventListener("click", (event) => {
          event.preventDefault();
          if (this.videoCertifiedHiddenInput)
            this.videoCertifiedHiddenInput.value = "";
          if (this.videoCertifiedSelectDisplay)
            this.videoCertifiedSelectDisplay.textContent = "All";
          this.videoCertifiedFilterGroup?.classList.remove("active");
          this.videoCertifiedClearButton.classList.remove("visible");
          if (this.videoCertifiedOptionsDropdown)
            this.videoCertifiedOptionsDropdown.classList.remove("open");
        });
      }

      if (this.videoCertifiedFilterGroup) {
        if (this.videoCertifiedSelectDisplay) {
          const newSelectDisplay =
            this.videoCertifiedSelectDisplay.cloneNode(true);
          if (this.videoCertifiedSelectDisplay.parentNode) {
            this.videoCertifiedSelectDisplay.parentNode.replaceChild(
              newSelectDisplay,
              this.videoCertifiedSelectDisplay
            );
          }
          this.videoCertifiedSelectDisplay = newSelectDisplay;
          this.videoCertifiedSelectDisplay.addEventListener(
            "click",
            (event) => {
              if (this._isApplyingFilters) {
                return;
              }

              event.stopPropagation();
              this.videoCertifiedOptionsDropdown?.classList.toggle("open");
            }
          );
        }
      }
    },

    registerVideoCertifiedToggleEvents: function () {
      if (!this.videoCertifiedToggle) {
        return;
      }

      const newToggle = this.videoCertifiedToggle.cloneNode(true);
      if (this.videoCertifiedToggle.parentNode) {
        this.videoCertifiedToggle.parentNode.replaceChild(
          newToggle,
          this.videoCertifiedToggle
        );
      }
      this.videoCertifiedToggle = newToggle;

      this.videoCertifiedToggle.addEventListener("change", () => {
        const isChecked = this.videoCertifiedToggle.checked;

        const facetDrawer = document.getElementById("Facet-Drawer");
        if (facetDrawer) {
          const mobileVideoCertifiedCheckboxes = facetDrawer.querySelectorAll(
            'input[type="checkbox"][name="filter.p.m.custom.certified"], input[type="checkbox"][name*="certified"], input[type="checkbox"][value="View all"]'
          );

          mobileVideoCertifiedCheckboxes.forEach((checkbox) => {
            checkbox.checked = isChecked;
          });
        }

        if (this.videoCertifiedHiddenInput) {
          this.videoCertifiedHiddenInput.value = isChecked ? "View all" : "";
        }
      });
    },

    registerTagEvents: function () {
      this.tagButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          button.classList.toggle("collection-tags__tag--active");

          // Limpiar parámetro de página al cambiar tags
          if (typeof window.clearPageParamOnFilterChange === "function") {
            window.clearPageParamOnFilterChange();
          }

          this.syncTagWithMobile(button);

          if (typeof window.applyFiltersGlobal === "function") {
            window.applyFiltersGlobal(true);
          }
        });
      });

      this.setupMobileTagSync();
    },

    syncTagWithMobile: function (tagButton) {
      const tagText = tagButton.textContent.trim();
      const isActive = tagButton.classList.contains(
        "collection-tags__tag--active"
      );

      const mobileCheckbox = document.querySelector(
        `#Facet-Drawer input[value="${tagText}"]`
      );

      if (mobileCheckbox) {
        mobileCheckbox.checked = isActive;

        const mobileTagElement = mobileCheckbox.closest("li");
        if (mobileTagElement) {
          if (isActive) {
            mobileTagElement.classList.add("active");
          } else {
            mobileTagElement.classList.remove("active");
          }
        }
      }
    },

    setupMobileTagSync: function () {
      const facetDrawer = document.getElementById("Facet-Drawer");
      if (!facetDrawer) return;

      const handleMobileTagChange = (event) => {
        const checkbox = event.target;

        if (checkbox.type === "checkbox" && checkbox.name === "filter.p.tag") {
          const tagValue = checkbox.value;
          const isChecked = checkbox.checked;

          const desktopTag = Array.from(this.tagButtons).find(
            (button) => button.textContent.trim() === tagValue
          );

          if (desktopTag) {
            if (isChecked) {
              desktopTag.classList.add("collection-tags__tag--active");
            } else {
              desktopTag.classList.remove("collection-tags__tag--active");
            }
          }
        }

        if (
          checkbox.type === "checkbox" &&
          (checkbox.name === "filter.p.m.custom.certified" ||
            checkbox.name.includes("certified") ||
            checkbox.value === "View all")
        ) {
          const isChecked = checkbox.checked;

          if (this.videoCertifiedToggle) {
            this.videoCertifiedToggle.checked = isChecked;
          }

          if (this.videoCertifiedHiddenInput) {
            this.videoCertifiedHiddenInput.value = isChecked ? "View all" : "";
          }

          if (this.videoCertifiedSelectDisplay) {
            this.videoCertifiedSelectDisplay.textContent = isChecked
              ? "View all"
              : "All";
          }

          if (this.videoCertifiedFilterGroup) {
            if (isChecked) {
              this.videoCertifiedFilterGroup.classList.add("active");
            } else {
              this.videoCertifiedFilterGroup.classList.remove("active");
            }
          }

          if (this.videoCertifiedClearButton) {
            if (isChecked) {
              this.videoCertifiedClearButton.classList.add("visible");
            } else {
              this.videoCertifiedClearButton.classList.remove("visible");
            }
          }
        }
      };

      facetDrawer.addEventListener("change", handleMobileTagChange);

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const tagCheckboxes = node.querySelectorAll
                ? node.querySelectorAll('input[name="filter.p.tag"]')
                : [];

              tagCheckboxes.forEach((checkbox) => {
                if (!checkbox.hasAttribute("data-sync-listener")) {
                  checkbox.setAttribute("data-sync-listener", "true");
                  checkbox.addEventListener("change", handleMobileTagChange);
                }
              });
            }
          });
        });
      });

      observer.observe(facetDrawer, { childList: true, subtree: true });

      const syncInitialTagState = () => {
        this.tagButtons.forEach((button) => {
          if (button.classList.contains("collection-tags__tag--active")) {
            this.syncTagWithMobile(button);
          }
        });

        const mobileTagCheckboxes = facetDrawer.querySelectorAll(
          'input[name="filter.p.tag"]'
        );
        mobileTagCheckboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            const tagValue = checkbox.value;
            const desktopTag = Array.from(this.tagButtons).find(
              (button) => button.textContent.trim() === tagValue
            );

            if (
              desktopTag &&
              !desktopTag.classList.contains("collection-tags__tag--active")
            ) {
              desktopTag.classList.add("collection-tags__tag--active");
            }
          }
        });
      };

      const drawerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class"
          ) {
            const isActive = facetDrawer.classList.contains("active");
            if (isActive) {
              setTimeout(syncInitialTagState, 100);
            }
          }
        });
      });

      drawerObserver.observe(facetDrawer, { attributes: true });
    },

    registerSearchEvents: function () {
      const mobileSearchInput = document.getElementById("mobile-search-input");
      const sideSearchInput = document.getElementById(
        "side-panel-search-input"
      );

      const syncAllSearchInputs = (sourceInput, sourceValue) => {
        const allInputs = [
          this.searchInput,
          mobileSearchInput,
          sideSearchInput,
        ].filter((input) => input && input !== sourceInput);

        allInputs.forEach((targetInput) => {
          if (targetInput.value !== sourceValue) {
            targetInput.value = sourceValue;
            const changeEvent = new Event("input", { bubbles: true });
            targetInput.dispatchEvent(changeEvent);
          }
        });
      };

      const setupSyncListeners = (sourceInput) => {
        if (!sourceInput) return;

        const syncIfNotPredictive = () => {
          const predictive = sourceInput
            .closest("search-form")
            ?.querySelector(".thb-predictive-search");
          if (!predictive || !predictive.classList.contains("active")) {
            if (
              (sourceInput.id === "search-input" ||
                sourceInput.id === "mobile-search-input") &&
              sourceInput.hasAttribute("data-user-cleared")
            ) {
              return;
            }
            syncAllSearchInputs(sourceInput, sourceInput.value);
          }
        };

        sourceInput.addEventListener("input", syncIfNotPredictive);
        sourceInput.addEventListener("keyup", syncIfNotPredictive);
        sourceInput.addEventListener("change", syncIfNotPredictive);
        sourceInput.addEventListener("blur", () => {
          setTimeout(syncIfNotPredictive, 100);
        });

        sourceInput.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.keyCode === 13) {
            const searchTerm = sourceInput.value.trim();
            if (
              !searchTerm.length &&
              sourceInput.id !== "search-input" &&
              sourceInput.id !== "mobile-search-input"
            ) {
              event.preventDefault();
              return false;
            }
          }
        });
      };

      setupSyncListeners(this.searchInput);
      setupSyncListeners(mobileSearchInput);
      setupSyncListeners(sideSearchInput);
    },

    hasActiveSearch: function () {
      const mobileSearchInput = document.getElementById("mobile-search-input");
      const desktopSearchInput = document.getElementById("search-input");
      const sideSearchInput = document.getElementById(
        "side-panel-search-input"
      );

      const mobileSearchValue = mobileSearchInput
        ? mobileSearchInput.value.trim()
        : "";
      const desktopSearchValue = desktopSearchInput
        ? desktopSearchInput.value.trim()
        : "";
      const sideSearchValue = sideSearchInput
        ? sideSearchInput.value.trim()
        : "";

      return (
        mobileSearchValue !== "" ||
        desktopSearchValue !== "" ||
        sideSearchValue !== ""
      );
    },

    goToSearchResults: function () {
      const mobileSearchInput = document.getElementById("mobile-search-input");
      const desktopSearchInput = document.getElementById("search-input");
      const sideSearchInput = document.getElementById(
        "side-panel-search-input"
      );

      let searchQuery = "";

      const searchInputs = [
        mobileSearchInput,
        desktopSearchInput,
        sideSearchInput,
      ];
      for (const input of searchInputs) {
        if (input && input.value.trim() !== "") {
          searchQuery = input.value.trim();
          break;
        }
      }

      if (searchQuery) {
        const searchUrl = `${
          window.location.origin
        }/search?q=${encodeURIComponent(searchQuery)}`;
        window.location.href = searchUrl;
      }
    },

    updateSearchInputDisplay: function (params) {},

    clearAllSearchInputs: function () {
      const mobileSearchInput = document.getElementById("mobile-search-input");
      const desktopSearchInput = document.getElementById("search-input");
      const sideSearchInput = document.getElementById(
        "side-panel-search-input"
      );

      [mobileSearchInput, desktopSearchInput, sideSearchInput].forEach(
        (input) => {
          if (input) {
            input.value = "";
            const changeEvent = new Event("input", { bubbles: true });
            input.dispatchEvent(changeEvent);
          }
        }
      );
    },

    clearSearchParamOnPageLoad: function () {},

    registerSortByEvents: function () {
      const sortByInput = document.getElementById("SortBy");
      if (!sortByInput) return;

      const customSortSelect = sortByInput.closest("custom-select");
      if (!customSortSelect) return;

      const sortItems = customSortSelect.querySelectorAll(
        ".custom-select--item"
      );
      const sortButtonTextElement = customSortSelect.querySelector(
        ".custom-select--button .custom-select--text"
      );

      if (!sortButtonTextElement) return;

      if (sortItems.length === 0) return;

      sortItems.forEach((item) => {
        const clone = item.cloneNode(true);
        if (item.parentNode) {
          item.parentNode.replaceChild(clone, item);
        }

        clone.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          const value = clone.dataset.value;

          if (sortByInput) {
            sortByInput.value = value;
          }

          if (sortButtonTextElement) {
            sortButtonTextElement.textContent = clone.textContent.trim();
          }

          customSortSelect
            .querySelectorAll(".custom-select--item")
            .forEach((sortItem) => {
              if (sortItem === clone) {
                sortItem.classList.add("selected");
              } else {
                sortItem.classList.remove("selected");
              }
            });

          if (customSortSelect.classList.contains("custom-select--active")) {
            customSortSelect.classList.remove("custom-select--active");
          }

          if (typeof window.clearPageParamOnFilterChange === "function") {
            window.clearPageParamOnFilterChange();
          }

          if (typeof window.applyFiltersGlobal === "function") {
            window.applyFiltersGlobal(true);
          }
        });
      });

      const sortByMobile = document.getElementById("SortByMobile");
      if (sortByMobile && !sortByMobile.hasAttribute("data-sort-listener")) {
        sortByMobile.setAttribute("data-sort-listener", "true");

        sortByMobile.addEventListener("change", (event) => {
          if (sortByInput) {
            sortByInput.value = event.target.value;
          }

          if (typeof window.clearPageParamOnFilterChange === "function") {
            window.clearPageParamOnFilterChange();
          }

          if (typeof window.applyFiltersGlobal === "function") {
            window.applyFiltersGlobal(true);
          }
        });
      }
    },

    closeDropdownsOnClickOutside: function () {
      if (this._globalClickListener) {
        document.removeEventListener("click", this._globalClickListener);
      }

      this._globalClickListener = (event) => {
        const isClickOnApplyButton =
          event.target.closest(".collection-filters__button") ||
          event.target.closest(".mobile-filters-apply") ||
          event.target.closest("button[type='submit']") ||
          (event.target.tagName === "BUTTON" &&
            event.target.textContent.includes("Search"));

        if (isClickOnApplyButton) {
          this.closeAllDropdowns();
          return;
        }

        const isClickOnPagination =
          event.target.closest("pagination-theme") ||
          event.target.closest(".pagination") ||
          event.target.closest("a[href*='page=']") ||
          event.target.closest(".pagination-item") ||
          event.target.closest(".load-more");

        if (isClickOnPagination) {
          return;
        }

        const isClickInsidePriceGroup = this.priceFilterGroup?.contains(
          event.target
        );
        const isClickInsideDeliveryGroup = this.deliveryFilterGroup?.contains(
          event.target
        );
        const isClickInsideVideoGroup =
          this.videoCertifiedFilterGroup?.contains(event.target);

        if (this.priceFilterGroup && !isClickInsidePriceGroup) {
          this.priceFilterGroup.classList.remove("active");
          if (this.priceRangeDropdown) {
            this.priceRangeDropdown.classList.remove("open");
          }
        }

        if (this.deliveryFilterGroup && !isClickInsideDeliveryGroup) {
          this.deliveryFilterGroup.classList.remove("active");
          if (this.deliveryOptionsDropdown) {
            this.deliveryOptionsDropdown.classList.remove("open");
          }
        }

        if (this.videoCertifiedFilterGroup && !isClickInsideVideoGroup) {
          this.videoCertifiedFilterGroup.classList.remove("active");
          if (this.videoCertifiedOptionsDropdown) {
            this.videoCertifiedOptionsDropdown.classList.remove("open");
          }
        }
      };

      document.addEventListener("click", this._globalClickListener);
    },

    _setupDeliveryInputObservers: function () {
      const updateDeliveryClearButton = () => {
        if (!this.deliveryClearButton) return;

        const hasActiveDelivery = !!(
          (this.deliveryHiddenInput &&
            this.deliveryHiddenInput.value &&
            this.deliveryHiddenInput.value.trim() !== "") ||
          (this.deliveryAuxInput &&
            this.deliveryAuxInput.value &&
            this.deliveryAuxInput.value.trim() !== "")
        );

        this.deliveryClearButton.style.display = hasActiveDelivery
          ? ""
          : "none";

        // Don't automatically add active class to prevent dropdown from opening during updates
        // The active class will be added when the user actually clicks on the delivery filter
      };

      if (this.deliveryHiddenInput) {
        const observerHidden = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "value"
            ) {
              updateDeliveryClearButton();
            }
          });
        });

        observerHidden.observe(this.deliveryHiddenInput, { attributes: true });
      }

      if (this.deliveryAuxInput) {
        const observerAux = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "value"
            ) {
              updateDeliveryClearButton();
            }
          });
        });

        observerAux.observe(this.deliveryAuxInput, { attributes: true });
      }

      updateDeliveryClearButton();
    },

    preventPaginationInterference: function () {
      document.addEventListener(
        "click",
        (event) => {
          const clickedLink = event.target.closest("a[href*='page=']");
          if (clickedLink) {
            const currentParams = new URLSearchParams(window.location.search);
            const hasActiveFilters =
              currentParams.has("filter.v.price.gte") ||
              currentParams.has("filter.v.price.lte") ||
              currentParams.has(
                "filter.p.m.wk_custom_field.cus_delivery_speed"
              ) ||
              currentParams.has("delivery") ||
              currentParams.has("filter.p.m.custom.certified") ||
              currentParams.has("filter.p.tag") ||
              currentParams.has("sort_by");

            if (hasActiveFilters) {
              return;
            }
          }
        },
        true
      );
    },

    closeAllDropdowns: function () {
      const allDeliveryGroups = document.querySelectorAll(
        ".delivery-filter-group"
      );

      allDeliveryGroups.forEach((group, index) => {
        const wasActive = group.classList.contains("active");
        group.classList.remove("active");
      });

      if (this.priceFilterGroup) {
        this.priceFilterGroup.classList.remove("active");
      }

      if (this.deliveryFilterGroup) {
        const wasActive = this.deliveryFilterGroup.classList.contains("active");
        this.deliveryFilterGroup.classList.remove("active");
      }

      if (this.videoCertifiedFilterGroup) {
        this.videoCertifiedFilterGroup.classList.remove("active");
      }

      if (this.priceRangeDropdown) {
        this.priceRangeDropdown.classList.remove("open");
      }
      if (this.videoCertifiedOptionsDropdown) {
        this.videoCertifiedOptionsDropdown.classList.remove("open");
      }

      const allPriceGroups = document.querySelectorAll(".price-filter-group");
      allPriceGroups.forEach((group) => {
        group.classList.remove("active");
      });

      const allVideoGroups = document.querySelectorAll(
        ".video-certified-filter-group"
      );
      allVideoGroups.forEach((group) => {
        group.classList.remove("active");
      });
    },

    syncSliderWithInputValues() {
      const mobileMinInput = document.getElementById("price-min-mobile");
      const mobileMaxInput = document.getElementById("price-max-mobile");
      const mobilePriceSlider = document.querySelector(
        "#Facet-Drawer custom-price-slider"
      );
      const desktopMinInput = document.getElementById("price-min");
      const desktopMaxInput = document.getElementById("price-max");
      const desktopPriceSlider = document.querySelector(
        "custom-price-slider:not(#Facet-Drawer custom-price-slider)"
      );

      if (
        !mobileMinInput ||
        !mobileMaxInput ||
        !mobilePriceSlider ||
        !mobilePriceSlider.noUiSliderInstance
      ) {
        return;
      }

      const inputMinValue = parseFloat(mobileMinInput.value) || 0;
      const inputMaxValue = parseFloat(mobileMaxInput.value) || 10000;
      const currentSliderValues = mobilePriceSlider.noUiSliderInstance
        .get()
        .map((v) => Number(v));

      if (
        Math.abs(currentSliderValues[0] - inputMinValue) > 1 ||
        Math.abs(currentSliderValues[1] - inputMaxValue) > 1
      ) {
        try {
          this.isSyncing = true;
          mobilePriceSlider.noUiSliderInstance.set(
            [inputMinValue, inputMaxValue],
            false
          );

          const mobileGteHidden = document.getElementById("price-gte-mobile");
          const mobileLteHidden = document.getElementById("price-lte-mobile");

          if (mobileGteHidden) mobileGteHidden.value = inputMinValue;
          if (mobileLteHidden) mobileLteHidden.value = inputMaxValue;

          if (desktopMinInput && desktopMinInput.value != inputMinValue) {
            desktopMinInput.value = inputMinValue;
          }
          if (desktopMaxInput && desktopMaxInput.value != inputMaxValue) {
            desktopMaxInput.value = inputMaxValue;
          }

          if (desktopPriceSlider && desktopPriceSlider.noUiSliderInstance) {
            const desktopSliderValues = desktopPriceSlider.noUiSliderInstance
              .get()
              .map((v) => Number(v));
            if (
              Math.abs(desktopSliderValues[0] - inputMinValue) > 1 ||
              Math.abs(desktopSliderValues[1] - inputMaxValue) > 1
            ) {
              desktopPriceSlider.noUiSliderInstance.set(
                [inputMinValue, inputMaxValue],
                false
              );
            }
          }

          const desktopGteHidden = document.getElementById("price-gte");
          const desktopLteHidden = document.getElementById("price-lte");
          if (desktopGteHidden) desktopGteHidden.value = inputMinValue;
          if (desktopLteHidden) desktopLteHidden.value = inputMaxValue;
        } catch (error) {
        } finally {
          setTimeout(() => {
            this.isSyncing = false;
          }, 50);
        }
      }
    },

    syncMobileHiddenInputsBeforeApply() {
      const mobileMinInput = document.getElementById("price-min-mobile");
      const mobileMaxInput = document.getElementById("price-max-mobile");
      const mobileGteHidden = document.getElementById("price-gte-mobile");
      const mobileLteHidden = document.getElementById("price-lte-mobile");

      if (
        !mobileMinInput ||
        !mobileMaxInput ||
        !mobileGteHidden ||
        !mobileLteHidden
      ) {
        return;
      }

      const inputMinValue =
        mobileMinInput.value && mobileMinInput.value.trim() !== ""
          ? parseFloat(mobileMinInput.value)
          : null;
      const inputMaxValue =
        mobileMaxInput.value && mobileMaxInput.value.trim() !== ""
          ? parseFloat(mobileMaxInput.value)
          : null;

      if (inputMinValue !== null && !isNaN(inputMinValue)) {
        mobileGteHidden.value = inputMinValue;
      }
      if (inputMaxValue !== null && !isNaN(inputMaxValue)) {
        mobileLteHidden.value = inputMaxValue;
      }

      const desktopMinInput = document.getElementById("price-min");
      const desktopMaxInput = document.getElementById("price-max");
      const desktopGteHidden = document.getElementById("price-gte");
      const desktopLteHidden = document.getElementById("price-lte");

      if (inputMinValue !== null && !isNaN(inputMinValue)) {
        if (desktopMinInput) desktopMinInput.value = inputMinValue;
        if (desktopGteHidden) desktopGteHidden.value = inputMinValue;
      }
      if (inputMaxValue !== null && !isNaN(inputMaxValue)) {
        if (desktopMaxInput) desktopMaxInput.value = inputMaxValue;
        if (desktopLteHidden) desktopLteHidden.value = inputMaxValue;
      }
    },
  };

  FilterUIManager.setupDynamicFiltersSync = function () {
    this.setupMobileDynamicFiltersListeners();
    this.setupDynamicFiltersClearButton();
  };

  FilterUIManager.setupMobileDynamicFiltersListeners = function () {
    const facetDrawer = document.getElementById("Facet-Drawer");
    if (!facetDrawer) return;

    const handleDynamicFilterChange = (event) => {
      const checkbox = event.target;

      if (
        checkbox.type === "checkbox" &&
        !checkbox.name.includes("price") &&
        !checkbox.name.includes("delivery") &&
        !checkbox.name.includes("certified") &&
        !checkbox.name.includes("filter.p.tag") &&
        checkbox.name.startsWith("filter.")
      ) {
        const facetDrawer = document.getElementById("Facet-Drawer");
        if (facetDrawer) {
          const sameFilterCheckboxes = facetDrawer.querySelectorAll(
            `input[name="${checkbox.name}"]:checked`
          );
          const checkedValues = Array.from(sameFilterCheckboxes).map(
            (cb) => cb.value
          );
        }
      }
    };

    facetDrawer.addEventListener("change", handleDynamicFilterChange);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const dynamicCheckboxes = node.querySelectorAll
              ? node.querySelectorAll(
                  'input[type="checkbox"][name^="filter."]:not([name*="price"]):not([name*="delivery"]):not([name*="certified"]):not([name*="filter.p.tag"])'
                )
              : [];

            dynamicCheckboxes.forEach((checkbox) => {
              if (!checkbox.hasAttribute("data-dynamic-filter-listener")) {
                checkbox.setAttribute("data-dynamic-filter-listener", "true");
              }
            });
          }
        });
      });
    });

    observer.observe(facetDrawer, { childList: true, subtree: true });

    const existingDynamicCheckboxes = facetDrawer.querySelectorAll(
      'input[type="checkbox"][name^="filter."]:not([name*="price"]):not([name*="delivery"]):not([name*="certified"]):not([name*="filter.p.tag"])'
    );

    existingDynamicCheckboxes.forEach((checkbox) => {
      if (!checkbox.hasAttribute("data-dynamic-filter-listener")) {
        checkbox.setAttribute("data-dynamic-filter-listener", "true");
      }
    });

    const drawerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const isActive = facetDrawer.classList.contains("active");
          if (isActive) {
            setTimeout(() => {
              this.reinitializeDynamicFilters();
            }, 200);
          }
        }
      });
    });

    drawerObserver.observe(facetDrawer, { attributes: true });
  };

  FilterUIManager.reinitializeDynamicFilters = function () {
    const facetDrawer = document.getElementById("Facet-Drawer");
    if (!facetDrawer) return;

    const dynamicCheckboxes = facetDrawer.querySelectorAll(
      'input[type="checkbox"][name^="filter."]:not([name*="price"]):not([name*="delivery"]):not([name*="certified"]):not([name*="filter.p.tag"])'
    );

    dynamicCheckboxes.forEach((checkbox) => {
      if (!checkbox.hasAttribute("data-dynamic-filter-listener")) {
        checkbox.setAttribute("data-dynamic-filter-listener", "true");
      }
    });
  };

  FilterUIManager.updateDynamicFiltersFromParams = function (params) {
    const facetDrawer = document.getElementById("Facet-Drawer");
    if (!facetDrawer) return;

    try {
      const dynamicCheckboxes = facetDrawer.querySelectorAll(
        'input[type="checkbox"][name^="filter."]:not([name*="price"]):not([name*="delivery"]):not([name*="certified"]):not([name*="filter.p.tag"])'
      );

      dynamicCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
        const listItem = checkbox.closest("li");
        if (listItem) {
          listItem.classList.remove("active");
        }
      });

      params.forEach((value, key) => {
        if (
          key.startsWith("filter.") &&
          !key.includes("price") &&
          !key.includes("delivery") &&
          !key.includes("certified") &&
          !key.includes("filter.p.tag")
        ) {
          const matchingCheckbox = Array.from(dynamicCheckboxes).find(
            (checkbox) => checkbox.name === key && checkbox.value === value
          );

          if (matchingCheckbox) {
            matchingCheckbox.checked = true;
            const listItem = matchingCheckbox.closest("li");
            if (listItem) {
              listItem.classList.add("active");
            }
          }
        }
      });

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.forEach((value, key) => {
        if (
          key.startsWith("filter.") &&
          !key.includes("price") &&
          !key.includes("delivery") &&
          !key.includes("certified") &&
          !key.includes("filter.p.tag")
        ) {
          const matchingCheckbox = Array.from(dynamicCheckboxes).find(
            (checkbox) => checkbox.name === key && checkbox.value === value
          );

          if (matchingCheckbox && !matchingCheckbox.checked) {
            matchingCheckbox.checked = true;
            const listItem = matchingCheckbox.closest("li");
            if (listItem) {
              listItem.classList.add("active");
            }
          }
        }
      });
    } catch (error) {
      console.warn(error);
    }
  };

  FilterUIManager.setupDynamicFiltersClearButton = function () {
    const clearButton = document.querySelector(".mobile-filters-clear");
    if (!clearButton) return;

    clearButton.addEventListener("click", () => {
      this.clearAllDynamicFilters();
      this.clearAllSearchInputs();
    });
  };

  FilterUIManager.clearAllDynamicFilters = function () {
    const facetDrawer = document.getElementById("Facet-Drawer");
    if (!facetDrawer) return;

    const dynamicCheckboxes = facetDrawer.querySelectorAll(
      'input[type="checkbox"][name^="filter."]:not([name*="price"]):not([name*="delivery"]):not([name*="certified"]):not([name*="filter.p.tag"])'
    );

    dynamicCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
      const listItem = checkbox.closest("li");
      if (listItem) {
        listItem.classList.remove("active");
      }
    });
  };

  window.FilterUIManager = FilterUIManager;

  window.closeAllFilterDropdowns = function () {
    if (
      FilterUIManager &&
      typeof FilterUIManager.closeAllDropdowns === "function"
    ) {
      FilterUIManager.closeAllDropdowns();
    }
  };

  window.clearPageParamOnFilterChange = function () {
    const currentParams = new URLSearchParams(window.location.search);
    if (currentParams.has("page")) {
      currentParams.delete("page");
      const newUrl = currentParams.toString()
        ? `${window.location.pathname}?${currentParams.toString()}`
        : window.location.pathname;
      history.replaceState(null, "", newUrl);
    }
  };

  FilterUIManager.init();

  const FilterSyncManager = {
    isDesktopPrimary: true,
    isSyncing: false,

    init() {
      this.setupBasicSync();
      this.setupPriceSync();
      this.detectMobileUsage();

      setTimeout(() => {
        this.syncPriceFilters();
        this.syncBothSlidersToCurrentValues();
      }, 1500);

      setTimeout(() => {
        this.syncBothSlidersToCurrentValues();
      }, 3000);
    },

    setupBasicSync() {
      const mobileDrawer = document.querySelector("#Facet-Drawer");
      if (mobileDrawer) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "class"
            ) {
              const isActive = mobileDrawer.classList.contains("active");
              if (isActive && !this.isSyncing) {
                setTimeout(() => {
                  this.syncDesktopToMobile();
                  this.syncPriceFilters();
                  this.ensureMobileSliderInitialization();
                  this.syncSliderWithInputValues();
                  this.syncBothSlidersToCurrentValues();
                }, 100);
              }
            }
          });
        });
        observer.observe(mobileDrawer, { attributes: true });
      }
    },

    ensureMobileSliderInitialization() {
      setTimeout(() => {
        this.setupMobilePriceInputsSync();
        this.initializeMobilePriceSlider();
      }, 300);
    },

    initializeMobilePriceSlider() {
      const facetDrawer = document.getElementById("Facet-Drawer");
      if (!facetDrawer) return;

      const mobilePriceSlider = facetDrawer.querySelector(
        "custom-price-slider"
      );
      if (!mobilePriceSlider) return;

      this.syncPriceFiltersBeforeInit();

      if (!mobilePriceSlider._isSliderFullyInitialized) {
        try {
          if (typeof mobilePriceSlider._initializeSlider === "function") {
            mobilePriceSlider._initializeSlider();
          } else {
            if (typeof mobilePriceSlider.connectedCallback === "function") {
              mobilePriceSlider.connectedCallback();
            }
          }
        } catch (error) {
          console.warn(
            "[FilterSyncManager] Error inicializando slider móvil:",
            error
          );
        }
      }

      this.setupMobileSliderListener(mobilePriceSlider);

      setTimeout(() => {
        this.ensureProperMobileRange();
        this.syncSliderWithInputValues();
        this.syncBothSlidersToCurrentValues();
      }, 100);
    },

    syncBothSlidersToCurrentValues() {
      const desktopGte = document.getElementById("price-gte");
      const desktopLte = document.getElementById("price-lte");

      if (desktopGte && desktopLte && desktopGte.value && desktopLte.value) {
        const currentMin = parseFloat(desktopGte.value);
        const currentMax = parseFloat(desktopLte.value);

        if (!isNaN(currentMin) && !isNaN(currentMax)) {
          this.ensureBothSlidersSync(currentMin, currentMax);
        }
      }
    },

    syncPriceFiltersBeforeInit() {
      try {
        const desktopGte = document.getElementById("price-gte");
        const desktopLte = document.getElementById("price-lte");
        const mobileGteHidden = document.getElementById("price-gte-mobile");
        const mobileLteHidden = document.getElementById("price-lte-mobile");

        if (desktopGte && desktopLte && mobileGteHidden && mobileLteHidden) {
          if (desktopGte.value && desktopLte.value) {
            mobileGteHidden.value = desktopGte.value;
            mobileLteHidden.value = desktopLte.value;
          }
        }
      } catch (error) {
        console.warn(
          "[FilterSyncManager] Error en sincronización previa:",
          error
        );
      }
    },

    ensureProperMobileRange() {
      const mobilePriceSlider = document.querySelector(
        "#Facet-Drawer custom-price-slider"
      );
      if (!mobilePriceSlider || !mobilePriceSlider.noUiSliderInstance) return;

      const sliderOptions = mobilePriceSlider.noUiSliderInstance.options;
      const currentValues = mobilePriceSlider.noUiSliderInstance
        .get()
        .map((v) => Number(v));

      if (
        sliderOptions.range.max <= sliderOptions.range.min ||
        sliderOptions.range.max === 10000
      ) {
        const desktopSlider = document.querySelector(
          "custom-price-slider:not(#Facet-Drawer custom-price-slider)"
        );
        if (desktopSlider && desktopSlider.noUiSliderInstance) {
          const desktopRange = desktopSlider.noUiSliderInstance.options.range;

          if (desktopRange.max > desktopRange.min) {
            mobilePriceSlider.noUiSliderInstance.updateOptions({
              range: {
                min: desktopRange.min,
                max: desktopRange.max,
              },
            });
          }
        }
      }

      setTimeout(() => {
        this.syncSliderWithInputValues();
      }, 200);
    },

    setupMobilePriceInputsSync() {
      const mobileMinInput = document.getElementById("price-min-mobile");
      const mobileMaxInput = document.getElementById("price-max-mobile");
      const mobileGteHidden = document.getElementById("price-gte-mobile");
      const mobileLteHidden = document.getElementById("price-lte-mobile");

      if (mobileMinInput && mobileMaxInput) {
        const getRangeLimits = () => {
          const minLimit = 0;
          const maxPlaceholder = mobileMaxInput.placeholder;
          const maxLimit = maxPlaceholder ? parseInt(maxPlaceholder) : 10000;
          return { minLimit, maxLimit };
        };

        const validatePriceInput = (inputType, value, otherValue, limits) => {
          const { minLimit, maxLimit } = limits;
          let validatedValue = value;

          switch (inputType) {
            case "min":
              switch (true) {
                case value < minLimit:
                  validatedValue = minLimit;
                  break;
                case value > maxLimit:
                  validatedValue = maxLimit;
                  break;
                case value > otherValue:
                  validatedValue = otherValue;
                  break;
                default:
                  validatedValue = value;
                  break;
              }
              break;

            case "max":
              switch (true) {
                case value < minLimit:
                  validatedValue = minLimit;
                  break;
                case value > maxLimit:
                  validatedValue = maxLimit;
                  break;
                case value < otherValue:
                  validatedValue = otherValue;
                  break;
                default:
                  validatedValue = value;
                  break;
              }
              break;

            default:
              validatedValue = value;
              break;
          }

          return validatedValue;
        };

        const syncMobilePriceInputs = () => {
          if (this.isSyncing) return;

          const limits = getRangeLimits();
          let minValue = parseInt(mobileMinInput.value) || 0;
          let maxValue = parseInt(mobileMaxInput.value) || limits.maxLimit;

          const validatedMin = validatePriceInput(
            "min",
            minValue,
            maxValue,
            limits
          );
          const validatedMax = validatePriceInput(
            "max",
            maxValue,
            validatedMin,
            limits
          );

          switch (true) {
            case validatedMin !== minValue:
              mobileMinInput.value = validatedMin;
              minValue = validatedMin;
              break;
          }

          switch (true) {
            case validatedMax !== maxValue:
              mobileMaxInput.value = validatedMax;
              maxValue = validatedMax;
              break;
          }

          if (mobileGteHidden) mobileGteHidden.value = minValue;
          if (mobileLteHidden) mobileLteHidden.value = maxValue;

          this.syncPriceFromMobileToDesktop({
            min: minValue,
            max: maxValue,
          });

          setTimeout(() => {
            this.syncSliderWithInputValues();
          }, 50);
        };

        const validateSpecificInput = (inputType) => {
          if (this.isSyncing) return;

          const limits = getRangeLimits();
          const minValue = parseInt(mobileMinInput.value) || 0;
          const maxValue = parseInt(mobileMaxInput.value) || limits.maxLimit;

          switch (inputType) {
            case "min":
              const validatedMin = validatePriceInput(
                "min",
                minValue,
                maxValue,
                limits
              );
              if (validatedMin !== minValue) {
                mobileMinInput.value = validatedMin;
                syncMobilePriceInputs();
              }
              break;

            case "max":
              const validatedMax = validatePriceInput(
                "max",
                maxValue,
                minValue,
                limits
              );
              if (validatedMax !== maxValue) {
                mobileMaxInput.value = validatedMax;
                syncMobilePriceInputs();
              }
              break;

            default:
              console.warn(
                "[FilterUIManager] Invalid input type for validation"
              );
              break;
          }
        };

        mobileMinInput.addEventListener("input", syncMobilePriceInputs);
        mobileMaxInput.addEventListener("input", syncMobilePriceInputs);
        mobileMinInput.addEventListener("change", syncMobilePriceInputs);
        mobileMaxInput.addEventListener("change", syncMobilePriceInputs);

        mobileMinInput.addEventListener("blur", () =>
          validateSpecificInput("min")
        );
        mobileMaxInput.addEventListener("blur", () =>
          validateSpecificInput("max")
        );

        const handleEnterKey = (e) => {
          switch (e.key) {
            case "Enter":
              syncMobilePriceInputs();
              break;
          }
        };

        mobileMinInput.addEventListener("keydown", handleEnterKey);
        mobileMaxInput.addEventListener("keydown", handleEnterKey);
      }
    },

    setupPriceSync() {
      const desktopPriceSlider = document.querySelector(
        "custom-price-slider:not(#Facet-Drawer custom-price-slider)"
      );
      if (desktopPriceSlider) {
        let desktopSyncTimeout;
        desktopPriceSlider.addEventListener("price-updated", (event) => {
          if (!this.isSyncing) {
            if (desktopSyncTimeout) {
              clearTimeout(desktopSyncTimeout);
            }

            desktopSyncTimeout = setTimeout(() => {
              this.syncPriceFromDesktopToMobile(event.detail);
            }, 50);
          }
        });
      }

      const mobileDrawer = document.querySelector("#Facet-Drawer");
      if (mobileDrawer) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const mobilePriceInputs = node.querySelector
                  ? node.querySelectorAll(
                      "#price-min-mobile, #price-max-mobile"
                    )
                  : [];
                if (mobilePriceInputs.length > 0) {
                  this.setupMobilePriceInputsSync();
                }

                const mobilePriceSlider = node.querySelector
                  ? node.querySelector("custom-price-slider")
                  : null;
                if (mobilePriceSlider) {
                  setTimeout(() => {
                    this.setupMobileSliderListener(mobilePriceSlider);
                  }, 200);
                }
              }
            });
          });
        });
        observer.observe(mobileDrawer, { childList: true, subtree: true });
      }

      this.setupDesktopPriceInputsSync();
      setTimeout(() => {
        this.setupMobilePriceInputsSync();
        this.setupMobileSliderListener();
      }, 1000);
    },

    setupMobileSliderListener(mobilePriceSlider) {
      if (!mobilePriceSlider) {
        mobilePriceSlider = document.querySelector(
          "#Facet-Drawer custom-price-slider"
        );
      }

      if (
        mobilePriceSlider &&
        !mobilePriceSlider.hasAttribute("data-sync-listener")
      ) {
        mobilePriceSlider.setAttribute("data-sync-listener", "true");

        let mobileSyncTimeout;
        mobilePriceSlider.addEventListener("price-updated", (event) => {
          if (!this.isSyncing) {
            if (mobileSyncTimeout) {
              clearTimeout(mobileSyncTimeout);
            }

            mobileSyncTimeout = setTimeout(() => {
              this.syncPriceFromMobileToDesktop(event.detail);
            }, 50);
          }
        });
      }
    },

    ensureBothSlidersSync(minValue, maxValue) {
      if (this.isSyncing) return;

      if (this._syncTimeout) {
        clearTimeout(this._syncTimeout);
      }

      this._syncTimeout = setTimeout(() => {
        const desktopPriceSlider = document.querySelector(
          "custom-price-slider:not(#Facet-Drawer custom-price-slider)"
        );
        const mobilePriceSlider = document.querySelector(
          "#Facet-Drawer custom-price-slider"
        );

        if (desktopPriceSlider && desktopPriceSlider.noUiSliderInstance) {
          const desktopValues = desktopPriceSlider.noUiSliderInstance
            .get()
            .map((v) => Number(v));
          if (
            Math.abs(desktopValues[0] - minValue) > 2 ||
            Math.abs(desktopValues[1] - maxValue) > 2
          ) {
            desktopPriceSlider.noUiSliderInstance.set(
              [minValue, maxValue],
              false
            );
          }
        }

        if (mobilePriceSlider && mobilePriceSlider.noUiSliderInstance) {
          const mobileValues = mobilePriceSlider.noUiSliderInstance
            .get()
            .map((v) => Number(v));
          if (
            Math.abs(mobileValues[0] - minValue) > 2 ||
            Math.abs(mobileValues[1] - maxValue) > 2
          ) {
            mobilePriceSlider.noUiSliderInstance.set(
              [minValue, maxValue],
              false
            );
          }
        }
      }, 100);
    },

    setupDesktopPriceInputsSync() {
      const desktopMinInput = document.getElementById("price-min");
      const desktopMaxInput = document.getElementById("price-max");

      if (desktopMinInput && desktopMaxInput) {
        const syncDesktopPriceInputs = () => {
          if (this.isSyncing) return;

          const minValue = parseInt(desktopMinInput.value) || 0;
          const maxValue = parseInt(desktopMaxInput.value) || 10000;

          this.syncPriceFromDesktopToMobile({
            min: minValue,
            max: maxValue,
          });
        };

        desktopMinInput.addEventListener("input", syncDesktopPriceInputs);
        desktopMaxInput.addEventListener("input", syncDesktopPriceInputs);
        desktopMinInput.addEventListener("change", syncDesktopPriceInputs);
        desktopMaxInput.addEventListener("change", syncDesktopPriceInputs);

        const handleDesktopEnterKey = (e) => {
          if (e.key === "Enter") {
            syncDesktopPriceInputs();
          }
        };

        desktopMinInput.addEventListener("keydown", handleDesktopEnterKey);
        desktopMaxInput.addEventListener("keydown", handleDesktopEnterKey);
      }
    },

    syncPriceFromDesktopToMobile(priceData) {
      this.isSyncing = true;

      try {
        const mobileMinInput = document.getElementById("price-min-mobile");
        const mobileMaxInput = document.getElementById("price-max-mobile");
        const mobileGteHidden = document.getElementById("price-gte-mobile");
        const mobileLteHidden = document.getElementById("price-lte-mobile");
        const mobilePriceSlider = document.querySelector(
          "#Facet-Drawer custom-price-slider"
        );

        if (mobileMinInput && mobileMinInput.value != priceData.min) {
          mobileMinInput.value = priceData.min;
        }
        if (mobileMaxInput && mobileMaxInput.value != priceData.max) {
          mobileMaxInput.value = priceData.max;
        }
        if (mobileGteHidden) mobileGteHidden.value = priceData.min;
        if (mobileLteHidden) mobileLteHidden.value = priceData.max;

        if (mobilePriceSlider && mobilePriceSlider.noUiSliderInstance) {
          const currentMobileValues = mobilePriceSlider.noUiSliderInstance
            .get()
            .map((v) => Number(v));
          if (
            Math.abs(currentMobileValues[0] - priceData.min) > 1 ||
            Math.abs(currentMobileValues[1] - priceData.max) > 1
          ) {
            mobilePriceSlider.noUiSliderInstance.set(
              [priceData.min, priceData.max],
              false
            );
          }
        }
      } catch (error) {
        console.warn("Error");
      } finally {
        setTimeout(() => {
          this.isSyncing = false;
        }, 50);
      }
    },

    syncPriceFromMobileToDesktop(priceData) {
      this.isSyncing = true;

      try {
        const desktopMinInput = document.getElementById("price-min");
        const desktopMaxInput = document.getElementById("price-max");
        const desktopGteHidden = document.getElementById("price-gte");
        const desktopLteHidden = document.getElementById("price-lte");
        const desktopPriceSlider = document.querySelector(
          "custom-price-slider:not(#Facet-Drawer custom-price-slider)"
        );

        if (desktopMinInput && desktopMinInput.value != priceData.min) {
          desktopMinInput.value = priceData.min;
        }
        if (desktopMaxInput && desktopMaxInput.value != priceData.max) {
          desktopMaxInput.value = priceData.max;
        }
        if (desktopGteHidden) desktopGteHidden.value = priceData.min;
        if (desktopLteHidden) desktopLteHidden.value = priceData.max;

        if (desktopPriceSlider && desktopPriceSlider.noUiSliderInstance) {
          const currentValues = desktopPriceSlider.noUiSliderInstance
            .get()
            .map((v) => Number(v));
          if (
            currentValues[0] != priceData.min ||
            currentValues[1] != priceData.max
          ) {
            desktopPriceSlider.noUiSliderInstance.set(
              [priceData.min, priceData.max],
              false
            );
          }
        }
      } catch (error) {
        console.warn(
          "[FilterSyncManager] Error syncing price from mobile to desktop:",
          error
        );
      } finally {
        setTimeout(() => {
          this.isSyncing = false;
        }, 50);
      }
    },

    syncPriceFilters() {
      try {
        const desktopGte = document.getElementById("price-gte");
        const desktopLte = document.getElementById("price-lte");
        const desktopMinInput = document.getElementById("price-min");
        const desktopMaxInput = document.getElementById("price-max");

        if (desktopGte && desktopLte) {
          const currentMin = desktopGte.value || "0";
          const currentMax = desktopLte.value || "10000";

          const mobileMinInput = document.getElementById("price-min-mobile");
          const mobileMaxInput = document.getElementById("price-max-mobile");
          const mobileGteHidden = document.getElementById("price-gte-mobile");
          const mobileLteHidden = document.getElementById("price-lte-mobile");

          if (mobileMinInput && mobileMinInput.value != parseInt(currentMin)) {
            mobileMinInput.value = parseInt(currentMin);
          }
          if (mobileMaxInput && mobileMaxInput.value != parseInt(currentMax)) {
            mobileMaxInput.value = parseInt(currentMax);
          }
          if (mobileGteHidden) mobileGteHidden.value = currentMin;
          if (mobileLteHidden) mobileLteHidden.value = currentMax;

          if (
            desktopMinInput &&
            desktopMinInput.value != parseInt(currentMin)
          ) {
            desktopMinInput.value = parseInt(currentMin);
          }
          if (
            desktopMaxInput &&
            desktopMaxInput.value != parseInt(currentMax)
          ) {
            desktopMaxInput.value = parseInt(currentMax);
          }
        } else {
          console.warn("[FilterSyncManager] Desktop price inputs not found");
        }
      } catch (error) {
        console.warn("[FilterSyncManager] Error syncing price filters:", error);
      }
    },

    syncDesktopToMobile() {
      if (this.isSyncing) return;
      this.isSyncing = true;

      try {
        // El search-input del desktop ya no se sincroniza porque es independiente
        // Solo sincronizamos otros elementos

        const desktopSort = document.querySelector("#SortBy");
        const mobileSort = document.querySelector("#SortByMobile");
        if (
          desktopSort &&
          mobileSort &&
          desktopSort.value !== mobileSort.value
        ) {
          mobileSort.value = desktopSort.value;
        }

        this.syncTagsDesktopToMobile();
        this.syncDeliveryDesktopToMobile();
      } catch (error) {
        console.warn("[FilterSyncManager] Error:", error);
      } finally {
        setTimeout(() => {
          this.isSyncing = false;
        }, 500);
      }
    },

    syncTagsDesktopToMobile() {
      try {
        const activeDesktopTags = document.querySelectorAll(
          ".collection-tags__tag--active"
        );
        const facetDrawer = document.getElementById("Facet-Drawer");

        if (!facetDrawer) return;

        const mobileTagCheckboxes = facetDrawer.querySelectorAll(
          'input[name="filter.p.tag"]'
        );
        const activeTagTexts = Array.from(activeDesktopTags).map((tag) =>
          tag.textContent.trim()
        );

        mobileTagCheckboxes.forEach((checkbox) => {
          const tagValue = checkbox.value;
          const shouldBeChecked = activeTagTexts.includes(tagValue);

          if (checkbox.checked !== shouldBeChecked) {
            checkbox.checked = shouldBeChecked;

            const tagElement = checkbox.closest("li");
            if (tagElement) {
              if (shouldBeChecked) {
                tagElement.classList.add("active");
              } else {
                tagElement.classList.remove("active");
              }
            }
          }
        });
      } catch (error) {
        console.warn("[FilterSyncManager] Error syncing tags:", error);
      }
    },

    syncDeliveryDesktopToMobile() {
      try {
        const desktopDeliveryInput = document.getElementById("delivery-input");
        const desktopDeliveryMetafield = document.getElementById(
          "delivery-metafield-input"
        );

        const currentDeliveryValue =
          desktopDeliveryInput?.value || desktopDeliveryMetafield?.value || "";

        const facetDrawer = document.getElementById("Facet-Drawer");
        if (!facetDrawer) return;

        const mobileDeliveryCheckboxes = facetDrawer.querySelectorAll(
          'input[name="filter.p.m.wk_custom_field.cus_delivery_speed"]'
        );

        mobileDeliveryCheckboxes.forEach((checkbox) => {
          const shouldBeChecked =
            checkbox.value === currentDeliveryValue &&
            currentDeliveryValue !== "";

          if (checkbox.checked !== shouldBeChecked) {
            checkbox.checked = shouldBeChecked;

            const deliveryElement = checkbox.closest("li");
            if (deliveryElement) {
              if (shouldBeChecked) {
                deliveryElement.classList.add("active");
              } else {
                deliveryElement.classList.remove("active");
              }
            }
          }
        });
      } catch (error) {
        console.warn("[FilterSyncManager] Error:", error);
      }
    },

    detectMobileUsage() {
      const closeButton = document.querySelector("#filter-drawer-close-btn");
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          this.isSyncing = false;
        });
      }
    },

    resetAllPriceInputs() {
      if (this.isSyncing) return;
      this.isSyncing = true;

      try {
        let defaultMin = 0;
        let defaultMax = 10000;

        const desktopPriceSlider = document.querySelector(
          "custom-price-slider:not(#Facet-Drawer custom-price-slider)"
        );

        if (desktopPriceSlider && desktopPriceSlider.noUiSliderInstance) {
          const sliderRange =
            desktopPriceSlider.noUiSliderInstance.options.range;
          defaultMin = sliderRange.min;
          defaultMax = sliderRange.max;

          try {
            if (typeof desktopPriceSlider.resetSlider === "function") {
              desktopPriceSlider.resetSlider();
            } else {
              desktopPriceSlider.noUiSliderInstance.set(
                [defaultMin, defaultMax],
                true
              );
            }
          } catch (error) {
            console.warn("[PRICE-RESET] Error:", error);
          }
        }

        const mobilePriceSlider = document.querySelector(
          "#Facet-Drawer custom-price-slider"
        );
        if (mobilePriceSlider && mobilePriceSlider.noUiSliderInstance) {
          try {
            if (typeof mobilePriceSlider.resetSlider === "function") {
              mobilePriceSlider.resetSlider();
            } else {
              mobilePriceSlider.noUiSliderInstance.set(
                [defaultMin, defaultMax],
                true
              );
            }
          } catch (error) {
            console.warn("[PRICE-RESET] Error:", error);
          }
        }

        const desktopMinInput = document.getElementById("price-min");
        const desktopMaxInput = document.getElementById("price-max");
        const desktopGteHidden = document.getElementById("price-gte");
        const desktopLteHidden = document.getElementById("price-lte");

        const mobileMinInput = document.getElementById("price-min-mobile");
        const mobileMaxInput = document.getElementById("price-max-mobile");
        const mobileGteHidden = document.getElementById("price-gte-mobile");
        const mobileLteHidden = document.getElementById("price-lte-mobile");

        if (desktopMinInput) desktopMinInput.value = defaultMin;
        if (desktopMaxInput) desktopMaxInput.value = defaultMax;
        if (desktopGteHidden) desktopGteHidden.value = defaultMin;
        if (desktopLteHidden) desktopLteHidden.value = defaultMax;

        if (mobileMinInput) mobileMinInput.value = defaultMin;
        if (mobileMaxInput) mobileMaxInput.value = defaultMax;
        if (mobileGteHidden) mobileGteHidden.value = defaultMin;
        if (mobileLteHidden) mobileLteHidden.value = defaultMax;
      } catch (error) {
        console.warn("Error:", error);
      } finally {
        setTimeout(() => {
          this.isSyncing = false;
        }, 50);
      }
    },
  };

  setTimeout(() => {
    try {
      FilterSyncManager.init();

      window.FilterSyncManager = FilterSyncManager;

      window.syncMobileSlider = function () {
        if (
          FilterSyncManager &&
          typeof FilterSyncManager.syncSliderWithInputValues === "function"
        ) {
          FilterSyncManager.syncSliderWithInputValues();
        }
      };

      window.syncMobileInputsBeforeApply = function () {
        if (
          FilterSyncManager &&
          typeof FilterSyncManager.syncMobileHiddenInputsBeforeApply ===
            "function"
        ) {
          FilterSyncManager.syncMobileHiddenInputsBeforeApply();
        }
      };

      window.syncAllPriceInputs = function () {
        if (
          FilterSyncManager &&
          typeof FilterSyncManager.syncPriceFilters === "function"
        ) {
          FilterSyncManager.syncPriceFilters();
        }
      };

      window.resetAllPriceInputs = function () {
        if (
          FilterSyncManager &&
          typeof FilterSyncManager.resetAllPriceInputs === "function"
        ) {
          FilterSyncManager.resetAllPriceInputs();
        }
      };

      window.syncBothSliders = function (minValue, maxValue) {
        if (
          FilterSyncManager &&
          typeof FilterSyncManager.ensureBothSlidersSync === "function"
        ) {
          FilterSyncManager.ensureBothSlidersSync(
            minValue || 0,
            maxValue || 10000
          );
        }
      };

      window.syncSliders = function () {
        if (
          FilterSyncManager &&
          typeof FilterSyncManager.syncBothSlidersToCurrentValues === "function"
        ) {
          FilterSyncManager.syncBothSlidersToCurrentValues();
        }
      };
    } catch (error) {
      console.warn("[FilterSyncManager] Error:", error);
    }
  }, 1000);

  function setupMobileFiltersAccordion() {
    const facetDrawer = document.getElementById("Facet-Drawer");
    if (!facetDrawer) return;

    function closeAllDetailsExcept(exceptElement) {
      const allDetails = facetDrawer.querySelectorAll(
        "details.thb-filter.js-filter"
      );
      allDetails.forEach((detail) => {
        if (detail !== exceptElement && detail.open) {
          detail.open = false;
        }
      });
    }

    function addAccordionListeners() {
      const allDetails = facetDrawer.querySelectorAll(
        "details.thb-filter.js-filter"
      );

      allDetails.forEach((detail) => {
        if (detail.hasAttribute("data-accordion-listener")) {
          return;
        }

        detail.setAttribute("data-accordion-listener", "true");

        detail.addEventListener("toggle", function (e) {
          if (this.open) {
            closeAllDetailsExcept(this);
          }
        });
      });
    }

    addAccordionListeners();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const newDetails = node.querySelectorAll
              ? node.querySelectorAll("details.thb-filter.js-filter")
              : [];

            if (newDetails.length > 0) {
              addAccordionListeners();
            }
          }
        });
      });
    });

    observer.observe(facetDrawer, { childList: true, subtree: true });

    const drawerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const isActive = facetDrawer.classList.contains("active");
          if (isActive) {
            setTimeout(() => {
              addAccordionListeners();
            }, 100);
          }
        }
      });
    });

    drawerObserver.observe(facetDrawer, { attributes: true });
  }

  setTimeout(() => {
    setupMobileFiltersAccordion();
  }, 200);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(setupMobileFiltersAccordion, 300);
    });
  }
});
